import { cn } from '@/lib/cn';

export const FEED_SLOTS = ['7am', '10am', '11am', '1pm', '3pm', '4pm', '7pm'] as const;

export function headerActionClass(primary?: boolean, tone?: 'stock') {
  return cn(
    'inline-flex min-h-[40px] items-center gap-2 rounded-lg border px-3.5 text-sm font-semibold transition-colors',
    tone === 'stock'
      ? 'border-amber-700 bg-amber-700 text-white hover:bg-amber-800'
      : primary
        ? 'border-primary-600 bg-primary-600 text-white hover:bg-primary-700'
        : 'border-gray-300 bg-white text-gray-900 hover:bg-gray-50'
  );
}

export const CATEGORY_LABEL: Record<string, string> = {
  probiotic: 'Probiotic',
  water_treatment: 'Water treatment',
  supplement: 'Supplement',
  feed_additive: 'Feed additive',
  chemical: 'Chemical',
  antibiotic: 'Antibiotic',
  other: 'Other',
};

export const categoryLabel = (c: string) => CATEGORY_LABEL[c] ?? c;

/** ABW in grams: round to 2 decimals first, then 2 decimals under 1 g and 1 decimal from 1 g (0.999 is "1.0 g"). */
export function abwText(v: number): string {
  const r = Math.round(v * 100) / 100;
  return `${r < 1 ? r.toFixed(2) : v.toFixed(1)} g`;
}

export function amountText(amount: string | number | null | undefined, unit: string | null | undefined): string {
  const n = amount === null || amount === undefined ? NaN : Number(amount);
  if (!Number.isFinite(n)) return '—';
  return `${n.toLocaleString(undefined, { maximumFractionDigits: 3 })}${unit ? ` ${unit}` : ''}`;
}
